/*
 * @Desc: 请求
 * @Author: zcc
 * @Date: 2022-11-22 13:58:39
 * @LastEditors: zhangyi zhangy.cosmo@haier.com
 * @LastEditTime: 2024-01-31 09:42:26
 */
import QueryString from 'qs'
import Cookies from 'js-cookie'
import router from '../router'
export default async ({ url = '', data = {}, params = {}, method = 'GET' }) => {
  if (process.env.NODE_ENV === 'development') {
    url = process.env.VUE_APP_BASE_API + url
  }

  method = method.toUpperCase()
  const requestConfig = {
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-User-Token': sessionStorage.getItem('token')
    }
  }
  if (method === 'GET') {
    url = url + QueryString.stringify(params)
  } else {
    Object.defineProperty(requestConfig, 'body', {
      value: JSON.stringify(data)
    })
  }
  try {
    const response = await fetch(url, requestConfig)
    const resJson = await response.json()
    const info = JSON.parse(sessionStorage.getItem('info'))
    const token = window.location.hostname === 'baas.cosmoplat.com' ? Cookies.get('cosmoplat-cosmoplatuuctoken') : Cookies.get('test-cosmoplat-cosmoplatuuctoken')
    if (response.status === 400 || response.status === 401) {
      console.log('400或401的校验', process.env.NODE_ENV)
      if (!token) {
        location.href = resJson.loginURL
      } else {
        router.push('/')
      }
    }
    return resJson
  } catch (err) {
    throw new Error(err)
  }
}
